import {
  ChangeDetectionStrategy,
  Component,
  InputSignal,
  input,
  InputSignalWithTransform,
  booleanAttribute
} from '@angular/core';
import { Agreement, AgreementStatus, AgreementType } from '@tdwb/lazy/platform/preferences';
import {
  ModalService,
  SecurityService
} from '@tdwb/core';
import { ConsolidatedAgreementsModalComponent } from './consolidated-agreements.modal.component';

@Component({
  selector: 'td-wb-consolidated-agreements-list',
  templateUrl: 'consolidated-agreements-list.component.html',
  styleUrls: ['consolidated-agreements-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ConsolidatedAgreementsListComponent {
  private static readonly TERMS_CONDITION_TYPES: ReadonlyArray<AgreementType> =
    [AgreementType.TDW_TERMS_AND_CONDITIONS, AgreementType.TDW_TERMS_AND_CONDITIONS_LITE];

  fplPermisson: boolean = false;

  readonly agreements: InputSignal<Array<Agreement>> = input<Array<Agreement>>([]);
  readonly newUser: InputSignalWithTransform<boolean, unknown> = input<boolean, unknown>(false, {
    alias: 'newUser',
    transform: booleanAttribute
  });

  readonly activeTrader: InputSignalWithTransform<boolean, unknown> = input<boolean, unknown>(false, {
    alias: 'activeTrader',
    transform: booleanAttribute
  });

  readonly superscriptRequired: InputSignalWithTransform<boolean, unknown> = input<boolean, unknown>(false, {
    alias: 'superscriptRequired',
    transform: booleanAttribute
  });

  readonly hideHeaders: InputSignalWithTransform<boolean, unknown> = input<boolean, unknown>(false, {
    alias: 'hideHeaders',
    transform: booleanAttribute
  });

  readonly alreadySigned: InputSignalWithTransform<boolean, unknown> = input<boolean, unknown>(false, {
    alias: 'alreadySigned',
    transform: booleanAttribute
  });

  constructor(private securityService: SecurityService,
              private modalService: ModalService) {
    this.fplPermisson = this.securityService.hasPermission('FULLY_PAID_LENDING');
  }

  getTermsConditions(): Agreement {
    return this.agreements()
      .find((item: Agreement): boolean => ConsolidatedAgreementsListComponent.TERMS_CONDITION_TYPES.indexOf(item.agreementType) >= 0);
  }

  getExchangeAgreements(): Array<Agreement> {
    return this.agreements()
      .filter((item: Agreement): boolean =>  ConsolidatedAgreementsListComponent.TERMS_CONDITION_TYPES.indexOf(item.agreementType) < 0);
  }

  getStockLendingAgreement(): Agreement {
    return {
      agreementType: AgreementType.STOCK_LENDING,
      agreementStatus: AgreementStatus.ACCEPTED
    };
  }

  onAgreementSelected(agreement: Agreement): void {
    this.modalService.open(ConsolidatedAgreementsModalComponent, undefined, { agreement });
  }
}
